import styled from "styled-components"
import { colors, scale, breakpoint } from "../../styles"
import {
	SECONDARY_MENU_HEIGHT_S,
	SECONDARY_MENU_HEIGHT_L,
} from "../SecondaryMenu"

export const SubmenuTriggerStyled = styled.button`
	position: relative;
	display: flex;
	align-items: center;
	white-space: nowrap;
	column-gap: 4px;
`

export const SubmenuMenuStyled = styled.nav`
	position: absolute;
	width: 100vw;
	padding: ${scale.px(4)} ${scale.px(3)};
	top: ${scale.px(SECONDARY_MENU_HEIGHT_S)};
	right: 0;
	background: ${colors.blue11};
	border: 1px solid ${colors.blue33};
	visibility: hidden;
	height: 0;
	overflow-x: hidden;

	&[aria-hidden="false"] {
		visibility: visible;
		height: auto;
	}

	${breakpoint("l")`
		width: ${scale.px(34)};
		top: ${scale.px(SECONDARY_MENU_HEIGHT_L)};
		padding: ${scale.px(4)} ${scale.px(5)};
	`}

	${breakpoint("xxl")`
		width: 100%;
		right: auto;
		left: 0;
	`}
`

export const DividerStyled = styled.span`
	height: 1px;
	width: 100%;
	background: ${colors.blue33};
	margin: ${scale.px(4)} ${scale.px(1)};
`
